import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"

import PlayerStatsAccordion from '../components/PlayerStatsAccordion';
import { fetchGameOfTheDay } from '../services/service';
import logo from '../assets/logo.jpeg';

function Home() {
  const [clue, setClue] = useState('');
  const [answerLength, setAnswerLength] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getTodayKey = () => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  };

  useEffect(() => {
    const todayKey = getTodayKey();
    const savedGame = localStorage.getItem('game');
    let parsed = null;
    if (savedGame) {
      parsed = JSON.parse(savedGame);
    }
    if (parsed && parsed.date === todayKey) {
      const data = parsed.data;
      setClue(data.clue);
      setAnswerLength(data.answerLength);
      setLoading(false);      
    } else {
      fetchGameOfTheDay().then(data => {
        setClue(data.clue);
        setAnswerLength(data.answerLength);
        setLoading(false);
        localStorage.setItem('game', JSON.stringify({
        date: todayKey,
        data: {
          answerLength: data.answerLength,
          par: data.par,
          clue: data.clue,
          coloredClue: data.coloredClue || data.clue.split(' ').map(word => ({ word, className: '' }))
        }
      }));
      });
    }
  }, []);

  return (
    <>
      <div className="App-container">
        <div className="logo-header">
          <img src={logo} alt="Críptico Logo" className="newspaper-logo" />
          <div className="logo-title">Críptico Diário</div>
        </div>
        <p>Desafie-se diariamente com uma pista de cryptic crossword.</p>
        <h2>Pista de hoje:</h2>
        {loading ? <p>Carregando pista...</p> : <p className='clue-text'>{clue} ({answerLength})</p>}
        <button onClick={() => navigate('/game')} style={{ marginTop: '2rem', fontSize: '1.1rem', padding: '0.5rem 1.5rem' }}>Jogar</button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
        <div className="player-stats-accordion-box">
          <PlayerStatsAccordion />
        </div>
      </div>
      <Analytics />
      <SpeedInsights />
    </>    
  );
}

export default Home;
